import application from 'application/application';

import templateUrl from './module-intimations.template.html';

import controller from './module-intimations.controller';

application.config([
	'$stateProvider',
	$stateProvider => {
		$stateProvider.state('root.default.module-intimations', {
			url: '/intimacoes',
			views: {
				'default@root.default': { templateUrl, controller }
			},
			data: {
				documentTitle: 'Intimações'
			}
		});
	}
]);
